export default (api) => ({
  get (id) {
    return api.get(`/register/workshop/${id}`)
  },
  getAll () {
    return api.get('/register/workshop/')
  },
  create (registration) {
    return api.post('/register/workshop/', registration)
  },
  update (id, registration) {
    return api.put(`/register/workshop/${id}`, registration)
  },
  delete (id) {
    return api.delete(`/register/workshop/${id}`)
  },
  renew (id) {
    return api.put(`/register/workshop/renew/${id}`)
  }
})
